import request from '@core/services/request';

export const carFaxAPI = {
	addEditCarFaxCreds: (carFaxCredentials: any) => request.postSpecial(`/CarFaxApi/AddEditCreds`, carFaxCredentials),
	refreshToken: (storeCode: any) => request.postSpecial(`/CarFaxApi/RefreshToken?storeCode=${storeCode}`),
	getAllStoresCredentials: () => request.get(`/CarFaxApi/GetAllStoresCredentials`),
	DecodeCarFax: (storeCode: any, vin: any) => request.get(`/CarFaxApi/DecodeCarFax?storeCode=${storeCode}&vin=${vin}`),
	getNewCarFaxURL: (storeCode: string, vin: string) => request.get(`/CarFaxApi/GetNewCarFaxURL?storeCode=${storeCode}&vin=${vin}`),
};
